import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-elearnio-loader',
  templateUrl: './elearnio-loader.component.html',
  styleUrls: ['./elearnio-loader.component.scss'],
  // eslint-disable-next-line
  standalone: false,
})
export class ElearnioLoaderComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
